import { Box, Container } from "@sembark-travel/ui-base"
import { Breadcrumbs } from "@sembark-travel/ui-router"
import { useNavigate } from "../../../../router"
import { generatePath } from "../../../../router-utils"
import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"
import { MergeTags } from "../../../../Tags"

export default function TripsTagsMergePage() {
	const navigate = useNavigate()
	const listPage = generatePath("/org/tags/trips")
	function navigateToList() {
		return navigate("/org/tags/trips")
	}
	return (
		<>
			<Helmet>
				<title>Merge Trip Tags</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_TAGS}>
				<Breadcrumbs
					title="Merge Trip Tags"
					items={[
						[listPage, "Trip Tags"],
						["", "Merge"],
					]}
				/>
				<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
					<Box maxWidth="6xl" marginX="auto">
						<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
							<Container paddingY="6">
								<MergeTags
									scope="trips"
									onSuccess={navigateToList}
									onCancel={navigateToList}
								/>
							</Container>
						</Box>
					</Box>
				</Box>
			</ForbidUnlessAuthorized>
		</>
	)
}
